import {
  ZAutocomplete,
  ZButton,
  ZCard,
  ZModal,
  ZText,
  ZTitle,
  ZIcon,
  ZInput,
  ZInputField,
  ZCaption,
  ZLoading,
  ZBadgeText,
  ZDivider,
  ZAlert,
  ZLink,
  ZPopover,
} from '@quero/zilla-vue';
import './_style.scss';

function installAtoms(Vue) {
  Vue.component('ZButton', ZButton);
  Vue.component('ZCard', ZCard);
  Vue.component('ZText', ZText);
  Vue.component('ZTitle', ZTitle);
  Vue.component('ZIcon', ZIcon);
  Vue.component('ZInput', ZInput);
  Vue.component('ZCaption', ZCaption);
  Vue.component('ZLoading', ZLoading);
  Vue.component('ZBadgeText', ZBadgeText);
  Vue.component('ZDivider', ZDivider);
  Vue.component('ZAlert', ZAlert);
  Vue.component('ZLink', ZLink);
  Vue.component('ZPopover', ZPopover);
}

function installMolecules(Vue) {
  Vue.component('ZAutocomplete', ZAutocomplete);
  Vue.component('ZInputField', ZInputField);
  Vue.component('ZModal', ZModal);
}

export default {
  install: (Vue) => {
    installAtoms(Vue);
    installMolecules(Vue);
  },
};
